export default __webpack_public_path__ + "static/media/metro-checkmark.dc83809a.svg";